export enum ProviderOnlineStatus {
  yes = "YES",
  no = "NO",
  callClinic = "CALL"
}
